import { UseFormReturn } from 'react-hook-form';

import { EOrganizedBy, ETripEvent, IApiFlightTripEvent, IFlightAPIEventData, ITripEvent } from 'detailsv2/structure';

import { ITripEventModalContentProps } from '../types';
import { FlightAPIOptions } from './FlightAPIOption/types';

export enum FlightTab {
  NUMBER_SEARCH,
  ROUTE_SEARCH,
  MANUAL,
}

interface IFlightTripEventModalCommonProps {
  methods: UseFormReturn;
  organizedBy: EOrganizedBy;
  handleSubmit: ITripEventModalContentProps['onSubmit'];
}

export interface IFlightTripEventModalContentProps extends IFlightTripEventModalCommonProps {
  tripEvent: IApiFlightTripEvent;
}

export interface IFlightManualTripEventModalContentProps extends IFlightTripEventModalCommonProps {
  tripEvent: ITripEvent<ETripEvent.Flight>;
}

export interface IDatesRange {
  start: string;
  end: string | null;
}

export interface IDateFlight {
  onChange: (value: string) => void;
  range?: IDatesRange;
  placeholder?: string;
  className?: string;
  errorMessage?: string;
  noRange?: boolean;
  isDisabled?: boolean;
}

export interface ISearchBy extends Omit<IFlightTripEventModalContentProps, 'methods' | 'res' | 'handleSubmit'> {
  hasSelectedValues: boolean;
  setSearchResults: (data: any) => void;
  setShowSelect: (val: boolean) => void;
  setActiveItems: React.Dispatch<React.SetStateAction<FlightAPIOptions>>;
}

export interface ISearchResultsProps {
  activeItems: FlightAPIOptions;
  setActiveItems: React.Dispatch<React.SetStateAction<FlightAPIOptions>>;
  searchResults: IFlightAPIEventData[] | null;
  showSelect: boolean;
  isNoData: boolean;
  methods: UseFormReturn;
}

export type DatePickerFormValues = Partial<
  Pick<IFlightManualTripEventModalContentProps['tripEvent'], 'datesRange' | 'daysRange'>
>;
